import { Sprout, BarChart3, TrendingUp, Layers } from "lucide-react";
import Reveal from "./Reveal";

const AUDIENCE = [
    {
        icon: Sprout,
        tone: "text-lav",
        ring: "border-electric/30 bg-electric/10",
        blob: "bg-electric/10",
        title: "BEGINNERS",
        body: "Beginners interested in learning trading fundamentals.",
    },
    {
        icon: BarChart3,
        tone: "text-neon",
        ring: "border-neon/30 bg-neon/10",
        blob: "bg-neon/10",
        title: "CANDLESTICK LEARNERS",
        body: "Traders who want to understand candlestick patterns.",
    },
    {
        icon: TrendingUp,
        tone: "text-lav",
        ring: "border-electric/30 bg-electric/10",
        blob: "bg-electric/10",
        title: "TECHNICAL ANALYSIS FANS",
        body: "Individuals interested in technical analysis.",
    },
    {
        icon: Layers,
        tone: "text-white",
        ring: "border-white/30 bg-white/10",
        blob: "bg-white/5",
        title: "MARKET STRUCTURE LEARNERS",
        body: "Traders looking to strengthen their understanding of market structure.",
    },
];

const ForYou = () => (
    <section data-testid="foryou-section" className="relative py-24 md:py-32">
        <div className="pointer-events-none absolute left-0 top-1/3 h-[420px] w-[420px] rounded-full bg-electric/10 blur-3xl" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal>
                <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-neon">
                    Untuk siapa
                </p>
                <h2 className="mt-5 max-w-3xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-6xl">
                    IS THIS WEBINAR{" "}
                    <span className="text-duo-grad">FOR YOU?</span>
                </h2>
            </Reveal>

            <div className="mt-14 grid gap-5 sm:grid-cols-2">
                {AUDIENCE.map((a, i) => (
                    <Reveal key={a.title} delay={0.08 * i}>
                        <div
                            data-testid={`foryou-card-${i + 1}`}
                            className="card-luxe group relative h-full overflow-hidden rounded-3xl p-8 transition duration-300 hover:-translate-y-1 hover:border-neon/40"
                        >
                            <div
                                className={`pointer-events-none absolute -right-12 -top-12 h-40 w-40 rounded-full ${a.blob} blur-2xl transition duration-300 group-hover:scale-125`}
                            />
                            <div className="relative flex items-center gap-4">
                                <span
                                    className={`inline-flex rounded-2xl border p-3 ${a.ring}`}
                                >
                                    <a.icon size={20} className={a.tone} />
                                </span>
                                <h3 className="font-display text-lg font-extrabold tracking-tight text-white md:text-xl">
                                    {a.title}
                                </h3>
                            </div>
                            <p className="relative mt-5 leading-relaxed text-white/65">
                                {a.body}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default ForYou;
